import React from "react"

import { FieldItems } from "@tenforce/toolbox-field-react"

import { ICheckListViewActions, IQuestion } from "../../.."

import DateFieldValue from "./DateFieldValue"
import NumberFieldValue from "./NumberFieldValue"
import PickerValue from "./PickerValue"
import ReadOnlyValue from "./ReadOnlyValue"
import TextFieldValue from "./TextFieldValue"
import TimeFieldValue from "./TimeFieldValue"
import ToggleValue from "./ToggleValue"

export interface Props extends IQuestion {
    contextMenuActions: ICheckListViewActions
}

export const QuestionValue = ({
    contextMenuActions,
    ...props
}: Props): JSX.Element => {
    const {
        controls: { canEditValue },
        type,
    } = props

    let content = <></>
    const isWrappedInFieldItems =
        type === "ToggleButton" ||
        type === "SinglePicker" ||
        type === "MultiPicker"

    // for non-picker/toggle values, the product fields is handling the read only state
    if (!canEditValue && isWrappedInFieldItems) {
        content = <ReadOnlyValue {...props} />
    } else {
        switch (type) {
            case "Number":
                content = (
                    <NumberFieldValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            case "Text":
                content = (
                    <TextFieldValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            case "Date":
                content = (
                    <DateFieldValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            case "Time":
                content = (
                    <TimeFieldValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            case "MultiPicker":
            case "SinglePicker":
                content = (
                    <PickerValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            case "ToggleButton":
                content = (
                    <ToggleValue
                        contextMenuActions={contextMenuActions}
                        {...props}
                    />
                )
                break
            default:
                return <></>
        }
    }

    return (
        <div
            data-ft-component="questionField"
            data-ft-type={type}
            data-ft-is-readonly={!canEditValue}
        >
            {isWrappedInFieldItems ? (
                <FieldItems>{content}</FieldItems>
            ) : (
                <>{content}</>
            )}
        </div>
    )
}

export default QuestionValue
